export default {
  toggleLoading(state, loading = false) {
    state.loading = loading;
  },
  setTags(state, tags) {
    state.tags = tags;
  },
  setTag(state, tag) {
    state.tag = tag;
  },
  setFilesImport(state, files) {
    state.files = files;
  },
  setTotalFiles(state, total) {
    state.total = total;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/store/mutations.js